import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { EndPoint } from '../config/endpoint';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private httpService: HttpService) {}

  async subscibeByPlan(body: any) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.NODE_SERVER}${EndPoint.teacher_payment}`, body),
      );
    } catch (error) {
      throw error;
    }
  }

  validateSubscription(body: { customerId: string }) {
    return this.httpService.post<any>(`${environment.NODE_SERVER}${EndPoint.validate_subscription}`, body);
  }

  async cancelSubscription(body: any) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.NODE_SERVER}${EndPoint.cancel_subscription}`, body),
      );
    } catch (error) {
      throw error;
    }
  }

  async createCustomer(body: any) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.NODE_SERVER}${EndPoint.create_stripe_customer}`, body),
      );
    } catch (error) {
      throw error;
    }
  }

  async updateLastSubscriptionPlan(body: any) {
    try {
      return await firstValueFrom(
        this.httpService.put<any>(`${environment.XANO_SERVER_URL}${EndPoint.update_user_last_subscription_plan}`, body),
      );
    } catch (error) {
      throw error;
    }
  }
}
